import React from 'react';

export default function Header({ lang, setLang, ttsEnabled, setTtsEnabled, messages, moduleName, onMobileMenu }) {
  const hasMessages = messages && messages.length > 0;

  return (
    <>
      <div className="emergency-bar">
        ⚠️ {lang === 'nl' ? 'Noodgeval? Bel 112 | Niet-spoed: 0900-8844' : 'Emergency? Call 112 | Non-urgent: 0900-8844'}
      </div>
      <div className="header">
        <div className="header-left">
          <button className="header-btn" onClick={onMobileMenu} style={{ display: 'none' }} id="mobile-menu-btn">
            ☰
          </button>
          <span className="header-title">🚔 AI POLICE</span>
          <span className="header-mode">
            {lang === 'nl' ? 'COMMAND CENTER' : 'COMMAND CENTER'}
          </span>
        </div>
        <div className="header-right">
          {/* TTS Toggle */}
          <button
            className={`header-btn${ttsEnabled ? ' active' : ''}`}
            onClick={() => setTtsEnabled(!ttsEnabled)}
            title={lang === 'nl' ? 'Voorleesfunctie' : 'Text-to-Speech'}
          >
            {ttsEnabled ? '🔊' : '🔇'}
          </button>

          {/* Transcript Download */}
          {hasMessages && (
            <button
              className="header-btn"
              onClick={() => {
                const { downloadTranscript } = require('../utils/speech');
                downloadTranscript(messages, moduleName || 'AI Police', lang);
              }}
              title={lang === 'nl' ? 'Transcript downloaden' : 'Download transcript'}
            >
              📥
            </button>
          )}

          {/* Language Toggle */}
          <button
            className={`header-btn lang-btn${lang === 'nl' ? ' active' : ''}`}
            onClick={() => setLang('nl')}
          >
            NL
          </button>
          <button
            className={`header-btn lang-btn${lang === 'en' ? ' active' : ''}`}
            onClick={() => setLang('en')}
          >
            EN
          </button>
        </div>
      </div>
    </>
  );
}
